import { supabase } from "../../config/supabase";

interface FertiProductData {
  product: string;
  countN: number;
  countP2O5: number;
  countK2O: number;
  countCaO: number;
  countMgO: number;
  countSO3: number;
  conductivity_ms_cm: number;
  specific_weight_kg_l: number;
  solubility_coeff: number;
}

class FertiProductService {
  async listFertiProducts() {
    try {
      const { data, error } = await supabase
        .from("ferti_products")
        .select("*")
        .order("product_name", { ascending: true });

      if (error) {
        console.error("Error fetching ferti_products:", error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error in listFertiProducts:", error);
      return { success: false, error };
    }
  }

  async existsFertiProductByName(product_name: string) {
    try {
      const { data, error } = await supabase
        .from("ferti_products")
        .select("id")
        .ilike("product_name", product_name);
      if (error) {
        console.error("Error checking ferti_product by name:", error);
        return { success: false, error };
      }
      return { success: true, exists: Array.isArray(data) && data.length > 0 };
    } catch (error) {
      console.error("Error in existsFertiProductByName:", error);
      return { success: false, error };
    }
  }
  async createFertiProduct(productData: FertiProductData) {
    try {
      const { data, error } = await supabase
        .from("ferti_products")
        .insert({
          ...productData,
          user_id: (await supabase.auth.getUser()).data.user?.id,
        })
        .select()
        .single();

      if (error) {
        console.error("Error creating ferti_product:", error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error in createFertiProduct:", error);
      return { success: false, error };
    }
  }

  async updateFertiProduct(productId: string, productData: FertiProductData) {
    try {
      const { data, error } = await supabase
        .from("ferti_products")
        .update(productData)
        .eq("id", productId)
        .select()
        .single();

      if (error) {
        console.error("Error updating ferti_product:", error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error in updateFertiProduct:", error);
      return { success: false, error };
    }
  }

  async deleteFertiProduct(productId: string) {
    try {
      const { error } = await supabase
        .from("ferti_products")
        .delete()
        .eq("id", productId);

      if (error) {
        console.error("Error deleting ferti_product:", error);
        return { success: false, error };
      }

      return { success: true };
    } catch (error) {
      console.error("Error in deleteFertiProduct:", error);
      return { success: false, error };
    }
  }

  async getFertiProductById(productId: string) {
    try {
      const { data, error } = await supabase
        .from("ferti_products")
        .select("*")
        .eq("id", productId)
        .single();

      if (error) {
        console.error("Error fetching ferti_product:", error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error in getFertiProductById:", error);
      return { success: false, error };
    }
  }
}

// Create and export a singleton instance
export const fertiProductService = new FertiProductService();
